// class DetailsDisclosure extends HTMLElement {
//   constructor() {
//     super();
//     this.mainDetailsToggle = this.querySelector('details');
//     this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

//     this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   onToggle() {
//     if (!this.animations) this.animations = this.content.getAnimations();

//     if (this.mainDetailsToggle.hasAttribute('open')) {
//       this.animations.forEach((animation) => animation.play());
//     } else {
//       this.animations.forEach((animation) => animation.cancel());
//     }
//   }

//   close() {
//     this.mainDetailsToggle.removeAttribute('open');
//     this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
//   }
// }

// customElements.define('details-disclosure', DetailsDisclosure);

// class HeaderMenu extends DetailsDisclosure {
//   constructor() {
//     super();
//     this.header = document.querySelector('.header-wrapper');
//   }

//   onToggle() {
//     if (!this.header) return;
//     this.header.preventHide = this.mainDetailsToggle.open;

//     if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     document.documentElement.style.setProperty(
//       '--header-bottom-position-desktop',
//       `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     );
//   }
// }

// customElements.define('header-menu', HeaderMenu);




class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;

    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary ? this.summary.nextElementSibling : null;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close(true);
    });
  }

  restartMegaAnimation() {
    if (!this.content) return;

    this.content.classList.remove('mega-menu-animate');

    // Force browser to restart animation every time
    void this.content.offsetWidth;

    this.content.classList.add('mega-menu-animate');
  }

  onToggle() {
    if (!this.content) return;

    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.restartMegaAnimation();
      this.animations.forEach((animation) => animation.play());
    } else {
      this.content.classList.remove('mega-menu-animate');
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  open() {
    if (!this.mainDetailsToggle || !this.content) return;

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.classList.add('menu-opening');
    this.content.classList.remove('mega-menu-instant-close');

    if (this.summary) {
      this.summary.setAttribute('aria-expanded', 'true');
    }

    this.restartMegaAnimation();
  }

  close(instant = false) {
    if (!this.mainDetailsToggle) return;

    this.mainDetailsToggle.classList.remove('menu-opening');

    if (this.content) {
      this.content.classList.remove('mega-menu-animate');

      if (instant) {
        this.content.classList.add('mega-menu-instant-close');
      }
    }

    this.mainDetailsToggle.removeAttribute('open');

    if (this.summary) {
      this.summary.setAttribute('aria-expanded', 'false');
    }

    if (this.content && instant) {
      requestAnimationFrame(() => {
        this.content.classList.remove('mega-menu-instant-close');
      });
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    this.closeTimer = null;
    this.desktopQuery = window.matchMedia('(min-width: 990px)');

    this._lastMouseX = 0;
    this._lastMouseY = 0;
    this._trackMouse = (event) => {
      this._lastMouseX = event.clientX;
      this._lastMouseY = event.clientY;
    };
    document.addEventListener('mousemove', this._trackMouse, { passive: true });

    this.initHoverMenu();
    this.initResizeObserver();
  }

  initHoverMenu() {
    if (!this.mainDetailsToggle || !this.summary) return;

    this.addEventListener('mouseenter', () => {
      if (!this.desktopQuery.matches) return;

      clearTimeout(this.closeTimer);

      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this && typeof menu.close === 'function') {
          menu.close(true);
        }
      });

      this.open();
    });

    this.addEventListener('mouseleave', () => {
      if (!this.desktopQuery.matches) return;

      clearTimeout(this.closeTimer);

      this.closeTimer = setTimeout(() => {
        const elAtPoint = document.elementFromPoint(this._lastMouseX, this._lastMouseY);
        if (elAtPoint && this.contains(elAtPoint)) {
          return;
        }
        this.close(true);
      }, 150);
    });

    this.addEventListener(
      'wheel',
      () => {
        if (!this.desktopQuery.matches) return;
        clearTimeout(this.closeTimer);
      },
      { passive: true }
    );

    this.summary.addEventListener(
      'click',
      (event) => {
        if (!this.desktopQuery.matches) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      },
      true
    );
  }

  initResizeObserver() {
    if (!this.header || typeof ResizeObserver === 'undefined') return;

    this._resizeObserver = new ResizeObserver(() => {
      if (this.mainDetailsToggle && this.mainDetailsToggle.open) {
        this.updateMegaMenuPosition();
      }
    });

    this._resizeObserver.observe(this.header);
  }

  updateMegaMenuPosition() {
    if (!this.header) return;

    const headerBottom = Math.floor(this.header.getBoundingClientRect().bottom);

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${headerBottom}px`
    );

    // ⚠️ Adjust this selector to match your actual nav markup —
    // it needs to select the <ul> that contains all top-level nav <li> items.
    const navList = this.closest('.header__inline-menu')?.querySelector('ul')
      || this.parentElement?.parentElement;

    let offset = 0;

    if (navList) {
      const navBottom = navList.getBoundingClientRect().bottom;  // bottom of the LAST row
      const itemBottom = this.getBoundingClientRect().bottom;    // bottom of THIS item's row

      // If the hovered item is already on the last row, navBottom === itemBottom → offset 0.
      // If it's on an earlier row, offset = height of the row(s) below it.
      offset = Math.max(0, Math.floor(navBottom - itemBottom));
    }

    const top = headerBottom - offset;

    document.documentElement.style.setProperty('--mega-menu-top', `${top}px`);
  }

  onToggle() {
    if (!this.header) return;

    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.restartMegaAnimation();
      this.updateMegaMenuPosition();
    } else if (this.content) {
      this.content.classList.remove('mega-menu-animate');
    }
  }

  disconnectedCallback() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
    document.removeEventListener('mousemove', this._trackMouse);
    clearTimeout(this.closeTimer);
  }
}

customElements.define('header-menu', HeaderMenu);

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    if (event.defaultPrevented) return;

    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer, menu-drawer')) return;

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});